<template>
  <v-data-table
    dense
    :headers="headers"
    :items="paymentMethods"
    :loading-text="$t('settings.paymentMethod.paymentMethodLoadingText')"
    :no-data-text="$t('settings.paymentMethod.noPaymentMethod')"
    mobile-breakpoint="768"
    :loading="loading"
    hide-default-footer
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-card-title class="pl-0">{{ $t('settings.paymentMethod.tableTitle') }}</v-card-title>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="$emit('open-new')"
          :disabled="loading"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
    </template>

    <template v-slot:item.label="{ item }">
      {{ getLabel(item) }}
    </template>

    <template v-slot:item.max_amount="{ item }">
      <!-- Currency code not available in settings context — amount displayed without symbol -->
      {{ item.max_amount != null ? item.max_amount : '—' }}
    </template>

    <template v-slot:item.max_quantity="{ item }">
      {{ item.max_quantity != null ? item.max_quantity : '—' }}
    </template>

    <template v-slot:item.activate="{ item }">
      <v-switch :input-value="item.activate" :disabled="loading" @change="$emit('toggle-activate', item)"></v-switch>
    </template>

    <template v-slot:item.actions="{ item }">
      <div class="d-flex justify-end">
        <v-btn icon @click="$emit('edit', item)" :disabled="loading">
          <v-icon color="primary">mdi-square-edit-outline</v-icon>
        </v-btn>
        <v-btn icon @click="$emit('delete', item)" :disabled="loading">
          <v-icon color="error">mdi-delete</v-icon>
        </v-btn>
      </div>
    </template>
  </v-data-table>
</template>

<script>

export default {
  name: 'PaymentMethodSettingsTable',
  props: {
    paymentMethods: {
      type: Array,
      default: () => [],
    },
    loading: Boolean,
  },
  computed: {
    headers() {
      return [
        { text: this.$t('settings.paymentMethod.label'), value: 'label' },
        { text: this.$t('settings.paymentMethod.maxQuantity'), value: 'max_quantity' },
        { text: this.$t('settings.paymentMethod.maxAmount'), value: 'max_amount' },
        { text: this.$t('settings.active'), value: 'activate' },
        { text: '', value: 'actions', sortable: false },
      ]
    },
  },
  methods: {
    getLabel(item) {
      const locale = this.$i18n.locale
      return item.labels?.[locale] || item.labels?.en || ''
    },
  },
}
</script>
